<template lang="html">
  <div class="question-container">
    <div class="close-icon-div">
      <v-btn flat icon @click = "$emit('close')"><i class="close-icon"></i></v-btn>
    </div>
    <div class="title--txt">
    </div>
    <div class="welcome-txt">
      Thank you very much for your completion!
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
@import "~styles/completion_questions.scss";
#app {

  .title--txt {
    flex-grow: 8;
  }
  .welcome-txt {
    text-align: center;
    flex-grow: 14;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionsTypes/QuestionDirectCompletionThanks.vue